// app/javascript/components/AdminGamesIndex.jsx
import React, { useEffect, useState } from "react";
import AdminNav from "./AdminNav";

export default function AdminGamesIndex() {
  const [games, setGames] = useState([]);
  const [draggedGameId, setDraggedGameId] = useState(null);
  const [savingOrder, setSavingOrder] = useState(false);

  useEffect(() => {
    fetch("/api/admin/games", {
      credentials: "include",
      headers: { Accept: "application/json" },
    })
      .then((r) => r.json())
      .then(setGames);
  }, []);

  const handleDelete = (gameId) => {
    if (!window.confirm("Delete this game?")) return;

    fetch(`/api/admin/games/${gameId}`, {
      method: "DELETE",
      credentials: "include",
      headers: {
        "X-CSRF-Token": document.querySelector("[name=csrf-token]").content,
      },
    }).then(() => {
      setGames((prev) => prev.filter((game) => game.id !== gameId));
    });
  };

  const saveOrder = (orderedGames) => {
    setSavingOrder(true);

    fetch("/api/admin/games/reorder", {
      method: "PATCH",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-CSRF-Token": document.querySelector("[name=csrf-token]").content,
      },
      body: JSON.stringify({
        game_ids: orderedGames.map((game) => game.id),
      }),
    })
      .then((response) => {
        if (!response.ok) throw new Error("Could not save game order");
        return response.json();
      })
      .then((data) => {
        setGames(Array.isArray(data) ? data : orderedGames);
      })
      .catch((error) => {
        alert(error.message);
      })
      .finally(() => {
        setSavingOrder(false);
      });
  };

  return (
    <div>
      <AdminNav />

      <main className="container my-4">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <div>
            <h1 className="mb-1">
              Games
              {savingOrder && (
                <span className="badge bg-secondary ms-2">Saving order...</span>
              )}
            </h1>
            <p className="text-muted mb-0">
              Manage games, descriptions, images, and publishing status.
            </p>
          </div>

          <a href="/admin/games/new" className="btn btn-success">
            + New Game
          </a>
        </div>

        <div className="card">
          <div className="card-body p-0">
            <table className="table table-hover mb-0 align-middle">
              <thead>
                <tr>
                  <th></th>
                  <th>Name</th>
                  <th>Slug</th>
                  <th>URL</th>
                  <th>Active</th>
                  <th>Sort Order</th>
                  <th className="text-end">Actions</th>
                </tr>
              </thead>

              <tbody>
                {games.map((game) => (
                  <tr
                    key={game.id}
                    draggable
                    onDragStart={() => setDraggedGameId(game.id)}
                    onDragOver={(event) => {
                      event.preventDefault();
                    }}
                    onDrop={() => {
                      if (!draggedGameId) return;

                      setGames((currentGames) => {
                        const draggedIndex = currentGames.findIndex(
                          (currentGame) => currentGame.id === draggedGameId,
                        );
                        const targetIndex = currentGames.findIndex(
                          (currentGame) => currentGame.id === game.id,
                        );

                        if (draggedIndex === -1 || targetIndex === -1)
                          return currentGames;

                        const reorderedGames = [...currentGames];
                        const [draggedGame] = reorderedGames.splice(
                          draggedIndex,
                          1,
                        );
                        reorderedGames.splice(targetIndex, 0, draggedGame);

                        saveOrder(reorderedGames);

                        return reorderedGames;
                      });

                      setDraggedGameId(null);
                    }}
                    onDragEnd={() => setDraggedGameId(null)}
                    className={draggedGameId === game.id ? "table-active" : ""}
                  >
                    <td
                      className="text-muted"
                      style={{ cursor: "grab", width: "40px" }}
                    >
                      ↕
                    </td>
                    <td className="fw-semibold">{game.name}</td>
                    <td>{game.slug}</td>

                    <td>
                      {game.url ? (
                        <a href={game.url} target="_blank" rel="noreferrer">
                          Open Link
                        </a>
                      ) : (
                        <span className="text-muted">No URL</span>
                      )}
                    </td>

                    <td>
                      {game.active ? (
                        <span className="badge bg-success">Active</span>
                      ) : (
                        <span className="badge bg-secondary">Hidden</span>
                      )}
                    </td>

                    <td>{game.sort_order}</td>

                    <td className="text-end">
                      <a
                        href={`/admin/games/${game.id}/edit`}
                        className="btn btn-sm btn-outline-primary me-2"
                      >
                        Edit
                      </a>

                      <button
                        className="btn btn-sm btn-outline-danger"
                        onClick={() => handleDelete(game.id)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}

                {games.length === 0 && (
                  <tr>
                    <td colSpan="7" className="text-center text-muted py-4">
                      No games have been added yet.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </main>
    </div>
  );
}
